// extracted by mini-css-extract-plugin
module.exports = {"activityListItem":"q746j","activityListItemDescription":"gcd-J","descriptionTextWrapper":"bRbs5","activityIconWrapper":"MmBRT","withPadding":"mAx2P"};